export const tagImpersonatedBuyer = () => {
  if (window.hj as any) hj('tagRecording', ['impersonated-buyer'])
}
